import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



  const cardData =
  {
    keyword: 'Mini Bus on Rent in Pune',
    heading: 'Amruta Travels: Mini Bus on Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Mini Bus on Rent in Pune, providing comfortable and reliable transportation for groups of all sizes. Perfect for corporate events, school trips, weddings, airport transfers, and outstation tours, our mini buses are equipped with push-back seats, air conditioning, and ample luggage space to ensure a relaxed journey. Whether you’re traveling within Pune or to nearby destinations like Mumbai, Mahabaleshwar, or Shirdi, our fleet ensures safety, punctuality, and luxury at every step. Driven by courteous and experienced chauffeurs, Amruta Travels’ Mini Bus Rental in Pune is the ideal choice for families, companies, and travel groups looking for convenience, comfort, and a premium travel experience.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Mini Bus on Rent in Pune",
      "description": "Mini Bus on Rent in Pune offers dependable, spacious, and comfortable transportation options tailored for groups of various sizes. Ideal for family outings, corporate events, school trips, and leisure tours, these mini buses come equipped with ample seating and luggage space to ensure a smooth and enjoyable journey. The fleet is well-maintained and undergoes regular safety checks, guaranteeing a reliable ride. Experienced drivers familiar with Pune’s traffic patterns ensure timely pickups and safe travel across the city and its outskirts. With flexible rental packages ranging from hourly to long-distance trips, this service prioritizes customer satisfaction by providing transparent pricing, excellent customer support, and seamless booking processes."
    },
    {
      "name": "Mini Bus Hire Pune",
      "description": "Mini Bus Hire Pune specializes in providing well-maintained mini buses for rent across Pune city and nearby areas. Catering to corporate groups, tourists, and families, this service offers customized travel solutions with a focus on punctuality, safety, and comfort. Each vehicle is cleaned and inspected regularly to ensure high standards. Professional chauffeurs, trained to handle Pune’s busy roads, ensure smooth and stress-free journeys. Whether for daily commuting, event transportation, or sightseeing tours, Mini Bus Hire Pune delivers reliable and affordable options with flexible booking terms."
    },
    {
      "name": "AC Mini Bus Pune",
      "description": "AC Mini Bus Pune ensures a cool and refreshing travel experience, especially suited to Pune’s warm climate. These fully air-conditioned mini buses offer premium comfort with spacious interiors, cushioned seats, and advanced climate control systems. Perfect for airport transfers, corporate meetings, leisure trips, and long-distance journeys, the service emphasizes passenger comfort and safety. Trained chauffeurs provide courteous and professional service, focusing on smooth driving and timely arrivals. Customers enjoy flexible rental plans, transparent pricing, and 24/7 support for hassle-free travel."
    },
    {
      "name": "Non AC Mini Bus Pune",
      "description": "Non AC Mini Bus Pune offers economical yet reliable group travel options without air conditioning, suitable for budget-conscious travelers and short city trips. Despite lacking AC, these mini buses maintain cleanliness, comfort, and safety, ensuring a pleasant ride for passengers. The vehicles are regularly maintained and inspected, driven by experienced drivers who prioritize punctuality and smooth navigation through Pune’s roads. This service is ideal for local commuting, school trips, and corporate outings where cost-efficiency is important without compromising service quality."
    },
    {
      "name": "Luxury Mini Bus Pune",
      "description": "Luxury Mini Bus Pune provides premium group travel with elegant and sophisticated vehicles designed to deliver a first-class experience. Featuring plush interiors, spacious seating, ambient lighting, and upscale amenities, these mini buses cater to weddings, VIP events, corporate functions, and special occasions. Attentive and discreet chauffeurs ensure a seamless journey marked by professionalism and personalized service. Clients enjoy flexible booking options, customized décor on request, and commitment to punctuality, making every trip memorable and comfortable."
    },
    {
      "name": "Mini Bus Hire Baner",
      "description": "Mini Bus Hire Baner caters specifically to the Baner locality, offering reliable and well-maintained mini buses for group transportation. Ideal for family outings, corporate events, and social gatherings, this service is known for punctuality, vehicle cleanliness, and courteous drivers. Flexible rental plans accommodate hourly, daily, or long-term needs, ensuring convenience and comfort for Baner residents and businesses alike."
    },
    {
      "name": "Mini Bus Hire Hinjewadi",
      "description": "Mini Bus Hire Hinjewadi specializes in servicing the IT and corporate hub of Hinjewadi, providing dependable mini bus rentals for employee commutes, client visits, and corporate events. The fleet consists of clean, well-maintained buses driven by professionals who understand the local traffic and schedules. The service offers timely pickups, safe travel, and comfortable interiors to support the demanding transportation needs of Hinjewadi’s business community."
    },
    {
      "name": "Mini Bus Hire Hadapsar",
      "description": "Mini Bus Hire Hadapsar offers group transport solutions tailored to the needs of residents and businesses in Hadapsar. These mini buses are ideal for office commutes, social events, and airport transfers, with a focus on punctuality and safety. Well-maintained vehicles and experienced drivers ensure comfortable and efficient travel within Hadapsar and nearby areas, backed by flexible booking and customer support."
    },
    {
      "name": "Mini Bus Hire Pimpri",
      "description": "Mini Bus Hire Pimpri provides reliable and affordable mini bus rentals for the Pimpri area, serving groups of all kinds—from employee transportation to family outings and business travel. The service features regularly inspected vehicles, professional chauffeurs, and flexible rental terms to accommodate short and long-term requirements. Safety and customer satisfaction are key priorities in delivering dependable transportation solutions."
    },
    {
      "name": "Corporate Mini Bus Pune",
      "description": "Corporate Mini Bus Pune specializes in offering professional transportation services for businesses, including employee shuttles, client transfers, and corporate events. The fleet comprises clean, well-equipped mini buses designed for comfort and efficiency, with drivers trained in corporate etiquette and safe driving practices. Flexible scheduling, punctual service, and customer-focused solutions help companies maintain smooth operations and employee satisfaction."
    },
    {
      "name": "Wedding Mini Bus Pune",
      "description": "Wedding Mini Bus Pune provides elegant and reliable group transport for weddings, receptions, and related ceremonies. The service includes well-maintained mini buses that can be decorated upon request to match wedding themes, ensuring a stylish and memorable journey. Experienced drivers handle logistics efficiently to guarantee timely arrivals and departures, adding convenience and luxury to your special day’s transportation."
    },
    {
      "name": "School Trip Mini Bus Pune",
      "description": "School Trip Mini Bus Pune offers safe, comfortable, and reliable transportation specifically designed for student groups. Each bus is equipped with safety features and is regularly maintained to meet high standards. Trained drivers prioritize child safety and timely schedules for school outings, educational tours, and extracurricular activities, providing peace of mind to parents and schools alike."
    },
    {
      "name": "Outstation Mini Bus Pune",
      "description": "Outstation Mini Bus Pune caters to groups traveling beyond Pune city limits, including leisure tours, business trips, and family vacations. These mini buses are equipped with spacious seating and adequate luggage capacity to ensure comfort during long journeys. Skilled drivers experienced in intercity routes prioritize safety, punctuality, and a smooth travel experience for all passengers."
    },
    {
      "name": "Affordable Mini Bus Rental Pune",
      "description": "Affordable Mini Bus Rental Pune focuses on providing budget-friendly yet reliable group transport services without compromising on safety or vehicle quality. This service is ideal for schools, small corporate groups, families, and social clubs looking for transparent pricing, flexible booking options, and dependable mini buses maintained to high standards."
    },
    {
      "name": "Mini Bus Booking Online Pune",
      "description": "Mini Bus Booking Online Pune offers a user-friendly digital platform for quick and easy reservation of mini buses. Customers can browse availability, select routes, choose vehicle types, and make secure payments with instant booking confirmation. This modern service supports 24/7 customer support and flexible cancellation policies, ensuring convenience and peace of mind."
    },
    {
      "name": "Mini Bus Hire near Me Pune",
      "description": "Mini Bus Hire near Me Pune ensures fast and localized access to mini bus rentals throughout Pune and surrounding suburbs. This service emphasizes prompt response times, flexible rental durations, and availability of well-maintained vehicles for immediate or scheduled travel. Professional drivers and transparent pricing make group travel hassle-free and accessible."
    },
    {
      "name": "Mini Bus Service 24x7 Pune",
      "description": "Mini Bus Service 24x7 Pune provides round-the-clock availability for group transportation needs, including emergency bookings, late-night transfers, and early morning departures. This reliable service guarantees that mini buses and professional drivers are accessible anytime, ensuring flexibility and peace of mind for clients with urgent or unconventional travel schedules."
    },
    {
      "name": "Best Mini Bus Rental Company Pune",
      "description": "Best Mini Bus Rental Company Pune is known for its commitment to excellence in vehicle quality, customer service, and reliability. Catering to a wide range of group travel needs—from corporate functions to leisure tours—this company offers a modern fleet of mini buses, experienced chauffeurs, and customized rental packages. Customers benefit from transparent pricing, flexible booking, and a reputation for punctuality and safety."
    }
  ],
  "tableData": [
    ["Mini Bus on Rent in Pune", "Mini Bus Hire Pune"],
    ["AC Mini Bus Pune", "Non AC Mini Bus Pune"],
    ["Luxury Mini Bus Pune", "Mini Bus Hire Baner"],
    ["Mini Bus Hire Hinjewadi", "Mini Bus Hire Hadapsar"],
    ["Mini Bus Hire Pimpri", "Corporate Mini Bus Pune"],
    ["Wedding Mini Bus Pune", "School Trip Mini Bus Pune"],
    ["Outstation Mini Bus Pune", "Affordable Mini Bus Rental Pune"],
    ["Mini Bus Booking Online Pune", "Mini Bus Hire near Me Pune"],
    ["Mini Bus Service 24x7 Pune", "Best Mini Bus Rental Company Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mini Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd provides convenient and comfortable mini bus rental services in Pune, perfect for group travel, tours, and events."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet of mini buses is regularly serviced and sanitized to ensure a safe and hygienic journey for all passengers."
  },
  {
    "WhyChooseheading": "Transparent and Fair Pricing",
    "WhyChoosedescription": "We offer competitive rates with no hidden charges—complete clarity in pricing from booking to drop-off."
  },
  {
    "WhyChooseheading": "Flexible Booking Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental packages tailored to your travel schedule and group size."
  },
  {
    "WhyChooseheading": "Trained and Courteous Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure your ride is safe, comfortable, and on time, every time."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Get assistance anytime with our dedicated customer support team, ready to help with bookings and inquiries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Experience",
    "WhyChoosedescription": "Reserve your mini bus quickly online or by phone, with doorstep service anywhere in Pune."
  },
  {
    "WhyChooseheading": "Reliable Group Travel Solutions",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is trusted by customers across Pune for safe, efficient, and enjoyable mini bus travel."
  }
]





















  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer mini bus rental services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides mini bus on rent services in Pune, perfect for group travel, corporate events, and sightseeing.',
  },
  {
    question: 'How can I book a mini bus in Pune with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are provided in the mini buses available for rent in Pune?',
    answer: 'Our mini buses come with comfortable seating, air conditioning, ample legroom, and essential safety features for a smooth journey.',
  },
  {
    question: 'Are the drivers trained and experienced for mini bus rentals in Pune?',
    answer: 'Yes, all drivers are professionally trained, courteous, and experienced in driving mini buses safely within Pune and nearby areas.',
  },
  {
    question: 'Can mini buses be rented for weddings, corporate events, tours, and airport transfers in Pune?',
    answer: 'Absolutely. Our mini buses are ideal for weddings, corporate outings, sightseeing tours, airport transfers, and more in Pune.',
  },
  {
    question: 'Is the mini bus hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers round-the-clock mini bus rental services in Pune to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for mini buses in Pune?',
    answer: 'We ensure all mini buses are thoroughly sanitized before each trip, and our drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What payment methods are accepted for mini bus rental in Pune?',
    answer: 'Payments can be made via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the mini bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'The mini bus from Amruta Travels Pune was spacious and comfortable. The driver was punctual and professional throughout our trip.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Great service! The mini bus was perfect for our corporate event in Pune. Highly recommend Amruta Travels for group transportation.',
    rating: 5,
  },
];




























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/assets/images/mini-bus-on-rent-in-pune.jpg",
  "description": "Book a Mini Bus on Rent in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury Mini Buses for corporate trips, weddings, school excursions, and outstation journeys at affordable prices with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "18156"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/mini-bus-on-rent-in-pune"
  }
};









  return (
    <div>
<Helmet>
  <title>Mini Bus on Rent in Pune | AC & Luxury Mini Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Mini Bus on Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury Mini Buses for weddings, corporate, school, and outstation travel. Affordable rates and 24x7 reliable service."
  />
  <meta
    name="keywords"
    content="Mini Bus on Rent in Pune, Mini Bus Hire Pune, AC Mini Bus Pune, Non AC Mini Bus Pune, Luxury Mini Bus Pune, Mini Bus Hire Baner, Mini Bus Hire Hinjewadi, Mini Bus Hire Hadapsar, Mini Bus Hire Pimpri, Corporate Mini Bus Pune, Wedding Mini Bus Pune, School Trip Mini Bus Pune, Outstation Mini Bus Pune, Affordable Mini Bus Rental Pune, Mini Bus Booking Online Pune, Mini Bus Hire near Me Pune, Mini Bus Service 24x7 Pune, Best Mini Bus Rental Company Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpune;